import './tabs.scss'

const selectors = {
  container: '[data-tabs]',
  tabHeader: '[data-tabs-header]',
  tabPane: '[data-tabs-pane]',
  active: 'active',
}

const setActive = (headers, panes, activeIndex) => {
  headers.forEach((header, index) => {
    header.classList[activeIndex === index ? 'add' : 'remove'](selectors.active)
  })
  panes.forEach((pane, index) => {
    pane.classList[activeIndex === index ? 'add' : 'remove'](selectors.active)
  })
}

const initTabs = (container) => {
  const headers = container.querySelectorAll(selectors.tabHeader)
  const panes = container.querySelectorAll(selectors.tabPane)

  headers?.forEach((header, activeIndex) => header.addEventListener('click', () => setActive(headers, panes, activeIndex)))

  setActive(headers, panes, 0)
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const containers = document.querySelectorAll(selectors.container)

    containers?.forEach(initTabs)
  },
  { once: true }
)
